import header  from '@js/components/header'
import swiper  from '@js/components/swiper'
import gsap    from '@js/libraries/gsap'
import lenis   from '@js/libraries/lenis'
import browser from '@js/utils/browser'
import general from '@js/utils/general'

$(() => {
	window.addEventListener('load', () => {
		general.init()

		// Libraries
		gsap.init()
		lenis.init()

		swiper.init()
		header.init()
		browser.init()
	})
})
